import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Spin } from 'antd';
import { needsTermsConsent } from '../../utils/termsConsent';

interface ProtectedRouteProps {
  children: React.ReactNode;
  /** Set to true for the /accept-terms route itself to avoid redirect loops */
  skipTermsCheck?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, skipTermsCheck = false }) => {
  const { isAuthenticated, isLoading, user } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="text-center">
          <Spin size="large" />
          <p className="mt-4 text-gray-600">Verifying session...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!skipTermsCheck && needsTermsConsent(user)) {
    return <Navigate to="/accept-terms" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
